/** @jsx jsx */
import { Box, Link, jsx } from "theme-ui"

const Footer = () => (
  <Box as="footer" variant="layout.footer">
    <br />
    <br />
    <br />
    <br />
    &copy; 2020
    {` `}
    <Link
      target="_blank"
      rel="noopener"
      href="https://www.linkedin.com/in/chuhe-wang-95ab09186/"
    >
      Chuhe Wang
    </Link>
    .{` `}
    All rights reserved.
    <br />
  </Box>
)

export default Footer
